export const POST_LOCATION = 'POST_LOCATION';

export const PUT_LOCATION = 'PUT_LOCATION';

export const REMOVE_LOCATION = 'REMOVE_LOCATION';

export const POST_BRANCHES = 'POST_BRANCHES';

export const PUT_BRANCHES = 'PUT_BRANCHES';

export const GET_BRANCHES = 'GET_BRANCHES';

export const INIT_FORM = {
  id: '',
  uuid: '',
  location_name: '',
  location_description: '',
  location_logo: '',

  pinned_address: '',
  geoloc: '',
  address_details: '',

  first_name: '',
  last_name: '',
  email_address: '',
  mobile_number: '',
  password: '',
  password_confirmation: '',
  system_status: 'INACTIVE',

  payment_methods: ['CASH_ON_DELIVERY', 'PAYMENT_GATEWAY'],
  payment_channels: [],
  delivery_couriers: [],
  has_delivery_options: true,
  scheduled_delivery: false,

  branches: [],
};
